
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    themes: {
      light: {
        primary: '#536DFE',
        second: '#263238',
        third: '#00BCD4',
        accent: '#FF80AB',
        error: '#E91E63',
        megogo: '#3eb8b3',
        megogoback: '#37474F',
        youtv: '#FF0000',
        youtvback: '#3eb8b3',
        headerback: '#23475f',
        footerback: '#999999',
        cardheader: '#23B684',
        cardheaderdark: '#074354',
        button: '#0F595E',
        infolight: '#BFE6EC'
      },
      dark: {
        primary: '#536DFE',
        second: '#263238',
        third: '#00BCD4',
        accent: '#FF80AB',
        error: '#E91E63',
        megogo: '#3eb8b3',
        megogoback: '#546E7A',
        youtv: '#FF0000',
        youtvback: '#3eb8b3',
      }
    },
  }

});
